import { useQuery } from '@tanstack/react-query';
import axiosInstance from '@/Api/axiosV2Config';
import type { AssistanceCancellationImpact } from '@/features/assistance/assistanceWording';

/**
 * Ce qui a déjà été transmis à l'assisteur pour un contrat, pour annoncer au vendeur
 * ce que son annulation entraînera réellement.
 *
 * Interrogé seulement à l'ouverture de la modale d'annulation, et seulement pour un
 * contrat qui porte une assistance : la question ne se pose pas autrement, et le
 * détail d'un contrat est chargé partout — y ajouter cette jointure la ferait payer
 * à tout le monde.
 *
 * Sans cache : l'état change dès qu'un flux part, et une réponse périmée annoncerait
 * au vendeur l'inverse de ce qui va se produire.
 */
export const useAssistanceCancellationImpact = (
  contractId: number | undefined,
  enabled: boolean,
) =>
  useQuery({
    queryKey: ['assistance', 'cancellation-impact', contractId],
    queryFn: async (): Promise<AssistanceCancellationImpact> => {
      const { data } = await axiosInstance.get<AssistanceCancellationImpact>(
        `/assistance-export/contracts/${contractId}/cancellation-impact`,
      );
      return data;
    },
    enabled: enabled && contractId != null,
    staleTime: 0,
  });
